import { GlobalStyles } from './core';
import { Provider as StoreProvider } from 'react-redux';
import ConfigureStore from './Configure.store';
import AppRouting from './App.routing';
import DialogProvider from "./components/react-async-dialog"
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer} from "react-toastify";
import { ShellThemeProvider, ThemeModes } from '@sede-enterprise/shell-ds-react-framework';
import { BrowserRouter } from 'react-router';
import { AuthenticationProvider } from './Authentication';

export interface IAppProps {}

export const App: React.FC<IAppProps> = () => {
  return (
    <AuthenticationProvider>
      <BrowserRouter>
        <StoreProvider store={ConfigureStore()}>
          <DialogProvider>
            <ShellThemeProvider theme={ThemeModes.dark} >
              <GlobalStyles />
              <AppRouting />
              <ToastContainer  theme={ThemeModes.light} />
            </ShellThemeProvider>
          </DialogProvider>
        </StoreProvider>
      </BrowserRouter>
    </AuthenticationProvider>
  );
};